<template>
  <div class="medicare-read-card">
    <medCodeSelector :visible="visible" />
    <el-button
      type="primary"
      size="small"
      @click="readDK('sendCardSB', '3', '90')"
    >
      社会保障卡
    </el-button>
    <!-- <el-button type="primary" size="small" @click="read('3')">
      社会保障卡
    </el-button> -->
    <el-button
      type="primary"
      size="small"
      @click="scanCodeDK()"
    >
      医保电子凭证
    </el-button>
    <!-- <el-button type="primary" size="small" @click="toScanCode()">
      医保电子凭证
    </el-button> -->
    <el-button
      type="primary"
      size="small"
      @click="readDK('sendCard', '2', '01')"
    >
      读取身份证号
    </el-button>
    <!-- <el-button type="primary" size="small" @click="read('2')">
      读取身份证号
    </el-button> -->

    <el-button type="primary" size="small" @click="dialogVisible = true" v-if ="isDev">
      测试读卡
    </el-button>

    <el-input
      v-model="cardNo"
      placeholder="身份证号"
      size="small"
      style="float: left; margin-left: 10px; width: 280px"
      v-on:keyup.enter.native="read('1', '0')"
      clearable
    >
      <el-button
        type="info"
        slot="append"
        icon="el-icon-search"
        :loading="loading"
        @click="read('1', '0')"
        style="width: 68px"
      >
        查询
      </el-button>
    </el-input>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="30%"
      append-to-body
      :before-close="beforeClose">
      <el-form ref="form" :model="testCardForm" label-width="80px">
        <el-form-item label="姓名">
          <el-input v-model="testCardForm.psn_name"></el-input>
        </el-form-item>
        <el-form-item label="证件号码">
          <el-input v-model="testCardForm.mdtrt_cert_no"></el-input>
        </el-form-item>
        <el-form-item label="证件类型">
          <el-radio-group v-model="testCardForm.cardType">
            <el-radio :label="'2'">身份证</el-radio>
            <el-radio :label="'3'">社保卡</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="testRead">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/components/_com/api";
import medApi from "@/common/medApi";
import { mapGetters } from "vuex";
// import scanCodeMixin from "./scanCodeMixin"; // 为调用 scanCode

const medCodeSelector = () =>
  import(/* webpackChunkName: 'medCodeSelector' */ "./medCodeSelector");

export default {
  name: "medicareReadCard",
  // mixins: [scanCodeMixin],
  components: { medCodeSelector },
  computed: { ...mapGetters(["token", "user", "readCardRawData"]) },
  props: {
    loading: Boolean,
    visible: Boolean
  },
  data() {
    return {
      showBaseinfo: false,
      cardNo: "",
      // mdtrt_cert_no: '',
      readCard: {},
      isDev: false,
      dialogVisible: false,
      testCardForm: {
        psn_name: '叶嘉棋',
        mdtrt_cert_no: '440183199712114049',
        cardType: '2',
      }
    };
  },
  mounted() {
    const { origin } = window.location;
    this.isDev = origin.indexOf("jiicm.com") === -1;
    console.log('isDev', this.isDev);
  },
  methods: {
    async read(mdtrt_cert_type, cardNo = "") {
      // http://localhost:10089/medapi/read/020/1/0
      this.$emit("update:loading", true);
      const result = await api.readInsuranceCard(
        this.$store.state.medCode,
        cardNo || "1101",
        mdtrt_cert_type,
        { mdtrtCertNo: this.mdtrt_cert_no },
        cardNo ? this.cardNo : ""
      );
      const item = result.context || result;
      this.readCard = item;
      if (result.message) {
        this.$message.error(`读卡失败：${result.message}!`);
        this.$emit("update:loading", false);
        return;
      }
      const data = {
        mdtrt_cert_type: item?.mdtrt_cert_type || mdtrt_cert_type, // 必填
        mdtrt_cert_no: item?.mdtrt_cert_no || this.mdtrt_cert_no, // 必填
        orgin_card_info: item?.orgin_card_info,
        sign: item?.sign,
        card_sn: item?.card_sn,
        begntime: item?.begntime,
        psn_cert_type: item?.psn_cert_type, // 必填
        certno: item?.certno,
        psn_name: item?.psn_name,
      };
      const header = {
        insuplc_admdvs: this.readCard.insuplc_admdvs,
        ip: this.readCard.ip,
        mac: this.readCard.mac,
      };
      const para = {
        header,
        input: { data },
      };
      this.execTrade(para, header);
    },
    execTrade(para, header) {
      const { medCode } = this.$store.state;
      medApi
        .execTrade(medCode, "1101", para)
        .then((res) => {
          this.$emit("update:loading", false);
          if (res.output && res.output.length) {
            res.medCode = medCode;
            res.readCard = this.readCard;
            res.header = header;
            this.$emit("read", res);
          } else {
            this.$message({
              type: "warning",
              message: "未获取到参保人信息！",
              showClose: true,
              duration: 15000,
            });
          }
        })
        .catch((err) => {
          if (err) {
            console.warn(40001, err);
            this.$message({
              type: "error",
              message: err.message || err,
              showClose: true,
              duration: 15000,
            });
          } else {
            this.$message.error("请求超时！");
          }
        })
        .finally(() => {
          this.$emit("update:loading", false);
        });
    },
    handleTrade(data, insuOrg) {
      // 20230607，一定要给this.readCard赋值，fee/pay.vue里api.medSellte的传参para会取this.readCard里的值。
      this.readCard.mdtrt_cert_type = "01";
      this.readCard.mdtrt_cert_no = data.mdtrt_cert_no;
      const { origin } = window.location;
      const admdvs = origin.indexOf("jiicm.com") !== -1 ? insuOrg : "440100";
      console.log(629999, data, "参保地", admdvs, this.readCard);
      const para = {
        header: {
          insuplc_admdvs: admdvs,
          ip: this.readCard.ip,
          mac: this.readCard.mac,
        },
        input: { data },
      };
      this.execTrade(para, para.header);
    },
    toScanCode() {
      this.scanCode((data, insuOrg) => {
        console.log(9992, data, insuOrg);
        this.handleTrade(data, insuOrg);
      });
    },
    /**
     *
     * @param dispatch dispatch方法
     * @param mdtrt_cert_type 就诊凭证类型
     * @param psn_cert_type 人员证件类型
     */
    readDK(dispatch, mdtrt_cert_type, _psn_cert_type) {
      this.$emit("update:loading", true);
      this.$store.dispatch(dispatch, {
        readType: '',
        message: this.$message,
        callback: () => {
          let psn_cert_type = _psn_cert_type
          if (mdtrt_cert_type == '3') {
            // 社保卡读卡广东省内的psn_cert_type用01，省外用90
            psn_cert_type = this.$store.state.insuplc_admdvs.startsWith('44') ? '01' : '90'
          }
          if (this.$store.state.readCardRawData.function == 'GetTwoBarCodes') {
            this.scanCodeDK()
          } else {
            this.$store.commit("setReadCardRawData", {
              mdtrt_cert_type,
              psn_cert_type,
            });
            const { pOutInfo, signBuffInfo, certno, psn_name, card_sn } =
              this.$store.state.readCardRawData.pOutInfo;
            const data = {
              mdtrt_cert_type, // 必填
              mdtrt_cert_no: certno, // 必填
              orgin_card_info: pOutInfo,
              sign: mdtrt_cert_type == '3' ? signBuffInfo : '',
              card_sn,
              begntime: null,
              psn_cert_type, // 必填
              certno,
              psn_name,
            };
            const header = {
              insuplc_admdvs: this.$store.state.insuplc_admdvs,
              ip: "10.10.21.175",
              mac: "4C-03-4F-58-66-A5",
            };
            const para = {
              header,
              input: { data },
            };
            this.execTrade(para, header);
          }
        },
      });
      setTimeout(() => {
        this.$emit("update:loading", false);
      }, 5000)
    },
    testRead() {
      const { mdtrt_cert_no, psn_name, cardType: mdtrt_cert_type } = this.testCardForm
      const psn_cert_type = mdtrt_cert_type == '2' ? '01' : '90'
      this.$store.commit('testReadCardRawData', {
        "libsName": "gzsyb-lib/SSCard",
        "function": "ReadCardBasGZ",
        "result": 0,
        "reinfo": "处理成功",
        "pOutInfo": {
          "pOutInfo": `|${mdtrt_cert_no}|544644322||${psn_name}|||||||`,
          "signBuffInfo": ""
        },
        "pOutInfoLength": 302
      })
      this.$store.commit("setReadCardRawData", {
        mdtrt_cert_type,
        psn_cert_type,
      });
      const header = {
        insuplc_admdvs: this.$store.state.insuplc_admdvs,
        ip: "10.10.21.175",
        mac: "4C-03-4F-58-66-A5",
      };
      const para = {
        header,
        input: {
          data: {
            "sign": "",
            "certno": mdtrt_cert_no,
            "card_sn": "",
            "begntime": "",
            psn_name,
            mdtrt_cert_no,
            psn_cert_type,
            mdtrt_cert_type,
            "orgin_card_info": `${psn_name}|${mdtrt_cert_no}|`
          }
        },
      };
      this.execTrade(para, header);
      this.beforeClose()
    },
    beforeClose() {
      this.testCardForm = {
        psn_name: '叶嘉棋',
        mdtrt_cert_no: '440183199712114049',
        cardType: '2',
      }
      this.dialogVisible = false
    },
    scanCodeDK() {
      const { origin } = window.location;
      // 扫码后返回的
      // DUmsocx1 = '{"url":"https://此处替换成中台地址/localcfc/api/hsecfc/localQrCodeQuery","indata":{"data":{"businessType":"01101","deviceType":"","officeId":"32760","officeName":"消化内科","operatorId":"test001","operatorName":"超级管理员","orgId":"35020319001"},"orgId":"35020319001","transType":"ec.query"}}';
      const ipUrl = 'http://19.15.78.136:20001/tst_nation_eccode/tst_eccode/localcfc/api/hsecfc/localQrCodeQuery';
      const testUrl = 'http://igb.hsa.gdgov.cn/tst_nation_eccode/tst_eccode/localcfc/api/hsecfc/localQrCodeQuery ';
      // const url = origin.indexOf('jiicm.com') !== -1 ? `${origin}/med/` : 'http://10.10.203.203:8204/med/';
      const prodUrl = 'http://igb.hsa.gdgov.cn/prd_nation_eccode/prd_eccode/localcfc/api/hsecfc/localQrCodeQuery';
      // const prodUrl = 'http://hosp-gz.gd.hsip.gov.cn/prd_nation_eccode/prd_eccode/localcfc/api/hsecfc/localQrCodeQuery'; // 20231228
      // const prodUrl = 'https://hosp-gz.gd.hsip.gov.cn/prd_nation_eccode/prd_eccode/localcfc/api/hsecfc/localQrCodeQuery'
      // const url = origin.indexOf('jiicm.com') !== -1 ? prodUrl : 'http://10.10.203.203:8204/med/';
      // 使用测试环境的地址
      const url = prodUrl;
      const payload = {
        "libsName": "NationECCode",
        "function": "NationEcTrans",
        "strUrl": url,
        "inData": JSON.stringify({
          data: {
            businessType: '01301', // ，01医院301结算
            deviceType: '', // SelfService
            officeId: this.user.deptCode,
            officeName: this.user.deptName,
            operatorId: this.user.id,
            operatorName: this.user.name,
            orgId: 'H44011201992' // H44010400081
          },
          orgId: 'H44011201992',
          transType: 'ec.query'
        })
      }
      this.$store.dispatch('scanCodeDK', {
        readCardType: 'qrcode',
        payload: JSON.stringify(payload),
        callback: (resData) => {
          this.$store.commit("setReadCardRawData", {
              mdtrt_cert_type: '01',
              psn_cert_type: resData.idType,
            });
          const data = {
            mdtrt_cert_type: '01',
            mdtrt_cert_no: resData.ecToken,
            certno: resData.idNo,
            orgin_card_info: '',
            sign: '',
            card_sn: '',
            begntime: '',
            psn_cert_type: resData.idType,
            psn_name: resData.userName
          }
          this.handleTrade(data, resData.insuOrg);
        }
      })
    },
  },
};
</script>

<style>
.medicare-read-card {
  width: 100%;
  margin-bottom: 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  overflow: hidden;
  display: flex;
}
.medicare-read-card .el-select,
.medicare-read-card .el-button {
  float: left;
  margin-right: 5px;
}
.medicare-read-card .el-select {
  width: 100px;
  margin-right: 10px;
}
</style>
